import React from 'react';
import NavBar from ".././pageChild/NavBar";
import Intagram from ".././pageChild/Intagram";
import Footer from ".././pageChild/Footer";
import End from ".././pageChild/End";
import callApi from './../../utils/apicaler';
import Tatca from "./Tatca";
import {
  Link
} from "react-router-dom";
 
class Xemthem extends React.Component{
  constructor(props){
            super(props);
            this.state = {
                status:0,
                carts:[],
                cartId:0,
            }
        } 

        componentDidMount(){
            sessionStorage.setItem("title", "Sản Phẩm");
            this.fucApi()
          var cart = JSON.parse(sessionStorage.getItem('products'));
          this.setState({carts:cart})
            if(cart === null){
                console.log("!")
            }else{
                cart.map((carts, index)=>{
                    this.setState({cartId: index + 1})
                })
            }
            
        }

        fucApi=()=>{
            callApi("", 'GET', null).then(res =>{
                this.setState({
                    status:res.status
                })
            })
        }

  render(){
    const {loader,cartId, status } = this.state;
    var title = sessionStorage.getItem('title');
    var wapper = <div className={`container-fluid custom_fluid ${loader}`} style={{background: "#e7eff7"}}>
                    <title>{title}</title>
                    <div className="row custom_row">
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                        <NavBar cartId={cartId} />
                      </div>
                    </div>
                   <div className="row custom_row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                            <div className="cart_img thoitrang"></div>
                        </div>
                    </div>
                    <div className="row custom_row">
                        <div className="title_pay">
                            <h3>Tất cả sản phẩm</h3>
                            <hr/>
                        </div>
                        <Tatca />
                        <Intagram />
                        <Footer />
                        <End />
                    </div>
                  
                    </div>
      return ( 
            <div>
            { status === 200 ? wapper : <div className="loader loader-black loader-1"></div>}
            </div>
     
              
  
        )
      }
  }
export default Xemthem;